import { Directive, Input, ElementRef, OnChanges } from '@angular/core';
import { OrderableItem, PanelItem, SizePrice, OrderableSpecialStepAlternativeItem } from 'ngx-web-api';

@Directive({
  selector: '[ftsDeactivated]',
})
export class DeactivatedDirective implements OnChanges {
  @Input()
  pnlItem: OrderableItem | PanelItem | OrderableSpecialStepAlternativeItem;
  @Input()
  selectedSize: SizePrice;

  constructor(private elRef: ElementRef) {}

  ngOnChanges() {
    if (!!this.pnlItem) {
      if (
        (!!this.pnlItem?.isItem &&
          !this.pnlItem.sizePrices.some(sp => sp.isFree) &&
          (this.selectedSize?.isUnavailable || !this.pnlItem.sizePrices.some(sp => sp.isAvailable))) ||
        this.pnlItem.pricePeriodMessage
      ) {
        this.getActiveElements().forEach(el => {
          el.setAttribute('disabled', true);
          el.classList.add('opaque');
        });
      } else {
        this.getActiveElements()
          .filter(el => el.attributes.disabled)
          .forEach(el => {
            el.removeAttribute('disabled');
            el.classList.remove('opaque');
          });
      }
    }
  }

  private getActiveElements(): any[] {
    return Array.from(this.elRef.nativeElement.querySelectorAll(`button`));
  }
}
